<template>
  <div :class="cn('flex h-80 flex-1 flex-col justify-between gap-4', props.class)">
    <PensionPortfolioValuePropositionTableRow
      v-for="(item, index) in structure"
      :row="item"
      :key="index"
      :isLoading
    />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  class?: ClassValue
  structure?: ValuePropositionTableRow[]
  isLoading?: boolean
}>()
</script>
